import { useSelector } from 'react-redux'
import { clientProductsTariffsSelectors } from '@ucheba/store/client-products/tariffs'
import { useMemo } from 'react'

export const useGetMaxDiscountByTariffs = (classValue?: string): number => {
  const entity = useSelector(clientProductsTariffsSelectors.entity)
  const productsByClassEntity = entity?.productsByClass

  const result = useMemo(() => {
    if (productsByClassEntity) {
      const res = productsByClassEntity.reduce((sum, item) => {
        if (classValue && classValue !== item.schoolClass.value) return sum

        const total = item.productsByTypeAndDuration.reduce(
          (productsByTypeSum, productsByType) => {
            const productsByTypeTotal = productsByType.products.reduce(
              (productSum, product) => {
                let countDiscountTotal = Object.values(product.byCountDiscounts).reduce(
                  (countDiscountsSum, countDiscount) => {
                    if (countDiscountsSum < countDiscount) {
                      return countDiscount
                    }

                    return countDiscountsSum
                  },
                  0
                )

                countDiscountTotal += product?.fullPaymentDiscount || 0

                if (countDiscountTotal > productSum) {
                  return countDiscountTotal
                }

                return productSum
              },
              0
            )

            if (productsByTypeTotal > productsByTypeSum) {
              return productsByTypeTotal
            }

            return productsByTypeSum
          },
          0
        )

        if (total > 0) {
          return total
        }

        return sum
      }, 0)

      return res
    }

    return 0
  }, [productsByClassEntity, classValue])

  return result
}
